var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"rounded bg-white rounded p-12 mb-12 shadow-md"},[_c('AccountSubscriptionOrderForm',{attrs:{"default-data":{}}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }